import "./card-style.css";
import React from "react";

function Periodos(props) {

    const handleClick = (index) => {

        const element = document.getElementById(index);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

    };

    return (
        <div className="container-periodos">
            {props.items.map((item, index) => {
                return (
                    <div key={index}>
                        <button onClick={()=>{handleClick(index)}} key={index}>{item}</button>
                        <span>|</span>
                    </div>
                )
            })}
        </div>
    )

}

export default Periodos;
